import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import * as Actions from 'actions';

import { FieldList, PipelineStepWrapper } from '../';

const copy = e => JSON.parse(JSON.stringify(e));
class PipelineField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editing : false,
      dirty : false,
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  handleSave(field) {
    if(!this.state.dirty) {
      return this.setState({editing : false});
    }
    this.setState({ dirty : false, editing : false});
    switch(field.entity) {
      case 'Client':
        return this.props.sendSocketEmit({
          client : this.state.dirtyEntity,
        }, 'client-update');
      case 'Job':
        return this.props.sendSocketEmit({
          job : this.state.dirtyEntity
        }, 'update-job');
    }
  }
  getValue(field, entity) {
    entity = copy(entity);
    let names = field.name.split('.');
    while(names.length > 1) {
      let name = names.shift();
      if(!entity[name]) {
        entity[name] = {}
      }
      entity = entity[name]
    }
    return entity[names.shift()];
  }
  handleChange(value, name, field, entity) {
    let copy_state = this.state.dirty? this.state.dirtyEntity : copy(entity);
    let newEntity = copy_state;
    let names = name.split('.');
    while(names.length > 1) {
      let name = names.shift();
      if(!newEntity[name]) {
        newEntity[name] = {};
      }
      newEntity = newEntity[name]
    }
    newEntity[names.shift()] = value;
    this.setState({ dirty : true, dirtyEntity : copy_state });
  }
  render() {
    const {dirty, dirtyEntity} = this.state;
    const {fields} = this.props;
    const field = fields.find(({_id}) => _id == this.props.field);
    if(!field) {
      return <div className="alert alert-warning">Field deleted or not loaded.</div>
    }
    let entity;
    switch(field.entity) {
      case 'Client':
      entity = this.props.client;
      break;
      case 'Job':
      entity = this.props.job;
      break;
      default:
      return <div className="alert alert-danger">Unsupported field.</div>
    }
    if(!entity) {
      return <div className="alert alert-info">No data loaded.</div>
    }
    let value = this.getValue(field, entity);

    return <PipelineStepWrapper completed={value && (value != '') ? true : false}>
      <Row>
        <Col xs={12}>
          <FieldList groupHeadings={false} readOnly={!this.state.editing} entity={!dirty? entity : dirtyEntity} fields={[field]} onChange={(value, name) => this.handleChange(value, name, field, entity)} />
        </Col>
        <Col xs={12}>
          {this.state.editing? (
            <div className="btn-group mt-xs mr-xs pull-right">
              <div onClick={e => this.setState({editing: false, dirty: false})} className="btn btn-sm btn-default"><i className="fa fa-close"></i></div>
              <div onClick={e => this.handleSave(field)} className='btn btn-sm btn-primary'><i className="fa fa-save"></i> Save</div>
            </div>
          ) : (
            <div onClick={e => this.setState({editing: true})} className="mt-xs mr-xs btn btn-sm btn-default pull-right"><i className="fa fa-cogs"></i> Modify</div>
          )}
        </Col>
      </Row>
    </PipelineStepWrapper>
  }
}

const getFieldArray = fields => {
  const names = Object.getOwnPropertyNames(fields);
  let aggregated_fields = [];
  names.forEach(name => {
    if(fields[name].constructor.name == 'Array') {
      aggregated_fields = [...aggregated_fields, ...fields[name]];
    }
  })
  return aggregated_fields;
}

const mapStateToProps = ({fields}) => ({fields : getFieldArray(fields)});

export default connect(mapStateToProps, Actions)(PipelineField);



// WEBPACK FOOTER //
// ./src/browser/components/pipeline/pipeline-field.js